import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { ErrorMessage } from '@/components/common/ErrorMessage'
import { AccountTypeBadge } from '@/components/common/AccountTypeBadge'
import { useAccounts } from '@/hooks/useAccounts'
import { Plus } from 'lucide-react'

export const AccountListPage = () => {
  const { data, isLoading, error } = useAccounts()

  if (error) {
    return <ErrorMessage message="Failed to load accounts. Please try again." />
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Accounts</h1>
        <Button asChild>
          <Link to="/accounts/new">
            <Plus className="mr-2 h-4 w-4" />
            New Account
          </Link>
        </Button>
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Type</TableHead>
                  <TableHead>Country</TableHead>
                  <TableHead>Devices</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.accounts && data.accounts.length > 0 ? (
                  data.accounts.map((account) => (
                    <TableRow key={account.id}>
                      <TableCell className="font-medium">
                        <Link to={`/accounts/${account.id}`} className="hover:underline">
                          {account.name}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <AccountTypeBadge accountType={account.accountType} />
                      </TableCell>
                      <TableCell>{account.country || '-'}</TableCell>
                      <TableCell>{account.deviceCount}</TableCell>
                      <TableCell>
                        {account.isActive ? (
                          <span className="text-green-600">Active</span>
                        ) : (
                          <span className="text-gray-400">Inactive</span>
                        )}
                      </TableCell>
                      <TableCell className="text-right">
                        <Button variant="outline" size="sm" asChild>
                          <Link to={`/accounts/${account.id}/edit`}>Edit</Link>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} className="text-center py-8 text-muted-foreground">
                      No accounts found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
